/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit ImageCapture.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-300.js"
import "DesignSystem/Fonts/WonderUnitSans-400.js"
import React from 'react'
import WelcomeIcon from 'DesignSystem/Svgs/WelcomeIcon/view.js'
import useIsMedia from 'Logic/useIsMedia.js'
import { css } from "emotion"

let styles = {}
styles.ImageCapture1 = css({label: 'ImageCapture1',
  backgroundColor: "#ffffff",
flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
  marginRight: 'var(--marginRight)',
marginLeft: 'var(--marginLeft)',
marginBottom: 'var(--marginBottom)'})
styles.Capture = css({label: 'Capture',
  marginTop: 2,
marginLeft: 2,
position: "relative",
  height: 'var(--height)',
width: 'var(--width)',
maxWidth: 'var(--maxWidth)'})
styles.ErrorMessage = css({label: 'ErrorMessage',
  flexDirection: "row",
alignItems: "center",
alignSelf: "flex-start",
backgroundColor: "#ffffff",
borderBottomLeftRadius: 15,
borderBottomRightRadius: 15,
borderTopLeftRadius: 15,
borderTopRightRadius: 15,
marginBottom: 15,
marginLeft: 15,
marginRight: 15,
maxWidth: 440,
paddingBottom: 20,
paddingLeft: 25,
paddingRight: 25,
paddingTop: 20,
boxShadow: "0px 4px 30px 0px rgba(180, 180, 180, 0.39)"})
styles.Text = css({label: 'Text',
  color: "#404040",
fontFamily: "WonderUnitSans",
lineHeight: 1.6,
marginLeft: 20,
wordBreak: "keep-all",
  fontSize: 'var(--fontSize)',
fontWeight: 'var(--fontWeight)'})
styles.Vertical = css({label: 'Vertical',
  alignItems: "center",
justifyContent: "center",
backgroundColor: "white",
borderBottomLeftRadius: 8,
borderBottomRightRadius: 8,
borderTopLeftRadius: 8,
borderTopRightRadius: 8,
pointerEvents: "none",
position: "absolute",
width: "100%",
  height: 'var(--height)',
boxShadow: `0px var(--shadowOffsetY) var(--shadowBlur) 0px rgba(142, 142, 142, 0.2)`})
styles.Headline = css({label: 'Headline',
  fontFamily: "WonderUnitSans",
fontSize: 18,
fontWeight: 400,
marginBottom: 8,
  textAlign: 'var(--textAlign)'})
styles.Subtext = css({label: 'Subtext',
  color: "#323232",
fontFamily: "WonderUnitSans",
fontSize: 16,
fontWeight: 300,
  textAlign: 'var(--textAlign)'})
styles.ImagePreview = css({label: 'ImagePreview',
  alignSelf: "center",
backgroundColor: "white",
pointerEvents: "none",
position: "absolute",
width: "100%",
  height: 'var(--height)'})
styles.Image = css({label: 'Image',
  pointerEvents: "none",
width: "100%",
  height: 'var(--height)'})
styles.ImagePreview1 = css({label: 'ImagePreview1',
  alignItems: "center",
justifyContent: "center",
alignSelf: "center",
backgroundColor: "white",
pointerEvents: "none",
position: "absolute",
width: "100%",
  height: 'var(--height)'})
styles.Text1 = css({label: 'Text1',
  fontFamily: "WonderUnitSans",
fontSize: 18,
fontWeight: 400,
marginBottom: 8,
  textAlign: 'var(--textAlign)'})

export default function ImageCapture({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  marginRight= 0,
marginLeft= 0,
marginBottom= 0,
accept,
height= 160,
onChange,
width= "auto",
maxWidth= 550,
hasError,
fontSize= 12,
fontWeight= 300,
shadowBlur= 15,
shadowOffsetY= 4,
text= "",
textAlign= "center",
label= "",
preview,
isPDF
}) {
    
    
    let isMedia = useIsMedia()
    
    
    

  return (<React.Fragment
>
<div
 data-testid="ImageCapture.ImageCapture:1"
 data-view-path={dataViewPath}
 style={{'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.ImageCapture1}`}
>
<input
 type="file"
 data-testid="ImageCapture.Capture"
 data-view-path={dataViewPath}
 accept={accept}
 onChange={onChange}
 style={{'--height': typeof height === 'number' ? `${height}px` : height,'--width': typeof width === 'number' ? `${width}px` : width,'--maxWidth': isMedia.mobile ? "320px" : maxWidth}}
 className={`views-capture ${styles.Capture}`}
/>
{
hasError ? 
<div
 data-testid="ImageCapture.ErrorMessage"
 data-view-path={dataViewPath}
 className={`views-block ${styles.ErrorMessage}`}
>
<WelcomeIcon
 data-testid="ImageCapture.WelcomeIcon"
 data-view-path={dataViewPath}
 marginTop={1}
/>
<span
 data-testid="ImageCapture.Text"
 data-view-path={dataViewPath}
 style={{'--fontSize': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fontWeight': fontWeight}}
 className={`views-text ${styles.Text}`}
>
File sizes larger than 10MB are not accepted. Please choose a smaller file.
</span>
</div>
 : null
}
<div
 data-testid="ImageCapture.Vertical"
 data-view-path={dataViewPath}
 style={{'--height': typeof height === 'number' ? `${height}px` : height,'--shadowBlur': typeof shadowBlur === 'number' ? `${shadowBlur}px` : shadowBlur,'--shadowOffsetY': typeof shadowOffsetY === 'number' ? `${shadowOffsetY}px` : shadowOffsetY}}
 className={`views-block ${styles.Vertical}`}
>
<span
 data-testid="ImageCapture.Headline"
 data-view-path={dataViewPath}
 style={{'--textAlign': textAlign}}
 className={`views-text ${styles.Headline}`}
>
{text}
</span>
<span
 data-testid="ImageCapture.Subtext"
 data-view-path={dataViewPath}
 style={{'--textAlign': textAlign}}
 className={`views-text ${styles.Subtext}`}
>
{label}
</span>
</div>
{
preview ? 
<div
 data-testid="ImageCapture.ImagePreview"
 data-view-path={dataViewPath}
 style={{'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.ImagePreview}`}
>
<img
 data-testid="ImageCapture.Image"
 data-view-path={dataViewPath}
 alt={""}
 src={preview}
 style={{'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Image}`}
/>
</div>
 : null
}
{
isPDF ? 
<div
 data-testid="ImageCapture.ImagePreview:1"
 data-view-path={dataViewPath}
 style={{'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.ImagePreview1}`}
>
<span
 data-testid="ImageCapture.Text:1"
 data-view-path={dataViewPath}
 style={{'--textAlign': textAlign}}
 className={`views-text ${styles.Text1}`}
>
You have uploaded a PDF
</span>
</div>
 : null
}
</div>
{children}
</React.Fragment>)
}